// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__1aCPZ","contained":"OpenButton_contained__2yh0x","disabled":"OpenButton_disabled__1k8N_","error":"OpenButton_error__2BhGw"};